import React, { useCallback, useState, useEffect } from 'react';

import { CITY_LIST } from '../data/cityList';
import { CLINIC_LIST } from '../data/clinicList';
import { CityId } from '../models/city';
import { calculateVh } from '../utils';
import styles from './App.module.css';
import { AppTitle } from './AppTitle';
import { ClinicCard } from './ClinicCard';
import { Drawer } from './Drawer';
import { Map } from './Map';
import { Tag } from './Tag';

export const App: React.FC = () => {
  const [activeClinic, setActiveClinic] = useState<number | undefined>();
  const [activeCity, setActiveCity] = useState(CityId.Nicosia);

  useEffect(() => {
    calculateVh();

    window.addEventListener('resize', calculateVh);

    return () => {
      window.removeEventListener('resize', calculateVh);
    };
  }, []);

  return (
    <div className={styles.container}>
      <Drawer>
        <header className={styles.header}>
          <AppTitle />
          {CITY_LIST.map((city, index) => (
            <Tag
              className={styles.city}
              isActive={city.id === activeCity}
              // theme={city.id === activeCity ? 'green' : 'white'}
              onClick={() => {
                setActiveCity(city.id);
              }}
              key={index}>
              {city.title}
            </Tag>
          ))}
        </header>
        <ul className={styles.clinics}>
          {CLINIC_LIST.filter(clinic => clinic.city === activeCity).map(
            (clinic, index) => (
              <ClinicCard
                key={`${clinic.city}-${index}`}
                clinic={clinic}
                isActive={activeClinic === clinic.id}
                onSelect={setActiveClinic}
              />
            ),
          )}
        </ul>
      </Drawer>
      <Map />
    </div>
  );
};
